'use client';

import styled, { css } from 'styled-components';

import * as mixin from '@wconcept/wconcept-ui/styles/mixin';

// ---------------- import
// icon
import bgActionbarBlack from './bg/bg_actionbar_black.svg';
import bgActionbarWhite from './bg/bg_actionbar_white.svg';
import bgCoupon from './bg/bg_coupon.svg';
import bgCoupon02 from './bg/bg_coupon02.svg';
import btnActionbarCateN32 from './btn/btn_actionbar_cate_n_32.svg';
import btnActionbarHeartN32 from './btn/btn_actionbar_heart_n_32.svg';
import btnActionbarHistoryN32 from './btn/btn_actionbar_history_n_32.svg';
import btnActionbarHome32 from './btn/btn_actionbar_home_32.svg';
import btnActionbarMyN32 from './btn/btn_actionbar_my_n_32.svg';
import btnBnbMen from './btn/btn_bnb_men.svg';
import btnBnbWomen from './btn/btn_bnb_women.svg';
import btnHeaderBack from './btn/btn_header_back.svg';
import btnHistory from './btn/btn_history.svg';
import btnPageTop from './btn/btn_page_top.svg';
import btnResetFilter from './btn/btn_reset_filter.svg';
import iconAlarm from './icon/icon_alarm.svg';
import iconArrow12 from './icon/icon_arrow12.svg';
import iconArrow20 from './icon/icon_arrow20.svg';
import iconArrow8 from './icon/icon_arrow8.svg';
import iconArrow24 from './icon/icon_arrow_24.svg';
import iconArrowGray24 from './icon/icon_arrow_g24.svg';
import iconArrowGray32 from './icon/icon_arrow_gray32.svg';
import iconArrGr5W16 from './icon/icon_arrow_gray5_16.svg';
import iconArrowGray17 from './icon/icon_arrow_gray_17.svg';
import iconArrowH17 from './icon/icon_arrow_h17.svg';
import iconArrowH18 from './icon/icon_arrow_h18.svg';
import iconArrowH9 from './icon/icon_arrow_h9.svg';
import iconArrowHdct16 from './icon/icon_arrow_hdct16.svg';
import iconArrowM01 from './icon/icon_arrow_m01.svg';
import iconArrowM02 from './icon/icon_arrow_m02.svg';
import iconArrowM15 from './icon/icon_arrow_m15.svg';
import iconArrowTW6 from './icon/icon_arrow_t_w6.svg';
import iconArrowW16 from './icon/icon_arrow_w16.svg';
import iconArrowW6 from './icon/icon_arrow_w6.svg';
import iconArrowW7 from './icon/icon_arrow_w7.svg';
import iconArrowW8 from './icon/icon_arrow_w8.svg';
import iconArrowW8H14 from './icon/icon_arrow_w8_h14.svg';
import iconCart from './icon/icon_cart.svg';
import iconCategory from './icon/icon_category.svg';
import iconCheck01 from './icon/icon_check_01.svg';
import iconCheck02 from './icon/icon_check_02.svg';
import iconCheckBox14 from './icon/icon_check_14.svg';
import iconCheckbox2C20 from './icon/icon_checkbox2_c_20.svg';
import iconCheckbox2N20 from './icon/icon_checkbox2_n_20.svg';
import iconCheckedWhite14 from './icon/icon_checked_white14.svg';
import iconCircleArrow from './icon/icon_circle_arrow.svg';
import iconClockBlack from './icon/icon_clock_black.svg';
import iconClose from './icon/icon_close.svg';
import iconClose2 from './icon/icon_close2.svg';
import iconDel16 from './icon/icon_del_16.svg';
import iconDel18 from './icon/icon_del_18.svg';
import iconDel20 from './icon/icon_del_20.svg';
import iconDownloadOnBlack from './icon/icon_download_on_black.svg';
import iconDownloadOnOrange from './icon/icon_download_on_orange.svg';
import iconErrorApi from './icon/icon_error_api.svg';
import iconErrorNetwork from './icon/icon_error_network.svg';
import iconErrorService from './icon/icon_error_service.svg';
import iconEvtLiveAlarm from './icon/icon_evt_live_alarm.svg';
import iconFacebook from './icon/icon_facebook.svg';
import iconGoto from './icon/icon_goto.svg';
import iconGridView from './icon/icon_grid_view.svg';
import iconHeart from './icon/icon_heart.svg';
import iconHeartB16 from './icon/icon_heart_b16.svg';
import iconHeartB9 from './icon/icon_heart_b9.svg';
import iconHeartG10 from './icon/icon_heart_g10.svg';
import iconHeartG19 from './icon/icon_heart_g19.svg';
import iconHome from './icon/icon_home.svg';
import iconInfo from './icon/icon_info.svg';
import iconInstargram from './icon/icon_instargram.svg';
import iconLike12 from './icon/icon_like_12.svg';
import iconListView from './icon/icon_list_view.svg';
import iconLiveAlarm from './icon/icon_live_alarm.svg';
import iconMovie from './icon/icon_movie.svg';
import iconMovie60 from './icon/icon_movie_60.svg';
import iconMy from './icon/icon_my.svg';
import iconMyheart from './icon/icon_myheart.svg';
import iconMyheart24 from './icon/icon_myheart_24.svg';
import iconOutlink from './icon/icon_outlink.svg';
import iconOutlink2 from './icon/icon_outlink2.svg';
import iconPhotoDelete20 from './icon/icon_photo_delete_20.svg';
import iconQuestion from './icon/icon_question.svg';
import iconRadio20 from './icon/icon_radio_20.svg';
import iconRefresh from './icon/icon_refresh.svg';
import iconReviewPhoto20 from './icon/icon_review_photo_20.svg';
import iconSearch from './icon/icon_search.svg';
import iconSelectArrow from './icon/icon_select_arrow.svg';
import iconSelectArrow12 from './icon/icon_select_arrow_12.svg';
import iconSelectBoxDownN12 from './icon/icon_select_box_down_n12.svg';
import iconSelectCategory from './icon/icon_select_category.svg';
import iconShare20 from './icon/icon_share_20.svg';
import iconShareFacebook38 from './icon/icon_share_facebook_38.svg';
import iconShareKakao38 from './icon/icon_share_kakao_38.svg';
import iconShareUrl38 from './icon/icon_share_url_38.svg';
import iconStar from './icon/icon_star.svg';
import iconStar2 from './icon/icon_star2.svg';
import iconTextbtnArrow18 from './icon/icon_textbtn_arrow_18.svg';
import iconTextbtnArrow19 from './icon/icon_textbtn_arrow_19.svg';
import iconTimeSale48 from './icon/icon_time_sale_48.svg';
import iconTimeSale72 from './icon/icon_time_sale_72.svg';
import iconYoutube from './icon/icon_youtube.svg';
// logo
import logoDstance from './logo/logo_dstance.svg';
import logoLodingW from './logo/logo_loding_w.svg';
import logoW from './logo/logo_W.svg';
import logoWconcept from './logo/logo_wconcept.svg';
import logoWconceptSsgLive from './logo/logo_wconcept_ssg_live.svg';

// bg

// ---------------- utils
const getStyle = (w: number, h: number) => css`
  ${mixin.getSizeBox(w, h)}
`;

// ---------------- styled
// icon
export const IconSearch = styled(iconSearch)`
  ${getStyle(32, 32)}
`;
export const IconAlarm = styled(iconAlarm)`
  ${getStyle(32, 32)}
`;
export const IconCart = styled(iconCart)`
  ${getStyle(32, 32)}
`;
export const IconHome = styled(iconHome)`
  ${getStyle(32, 32)}
`;
export const IconCategory = styled(iconCategory)`
  ${getStyle(32, 32)}
`;
export const IconMyheart = styled(iconMyheart)`
  ${getStyle(32, 32)}
`;
export const IconMyheart24 = styled(iconMyheart24)`
  ${getStyle(24, 24)}
`;
export const IconMy = styled(iconMy)`
  ${getStyle(32, 32)}
`;
export const IconSelArrow = styled(iconSelectArrow)`
  ${getStyle(16, 16)}
`;
export const IconSelectArrow12 = styled(iconSelectArrow12)`
  ${getStyle(12, 12)}
`;
export const IconSelectBoxDownN12 = styled(iconSelectBoxDownN12)`
  ${getStyle(16, 15)}
`;
export const IconHeart = styled(iconHeart)`
  ${getStyle(16, 16)}
`;
export const IconHeartB9 = styled(iconHeartB9)`
  ${getStyle(10, 9)}
`;
export const IconHeartB16 = styled(iconHeartB16)`
  ${getStyle(16, 16)}
`;
export const IconHeartG10 = styled(iconHeartG10)`
  ${getStyle(11, 10)}
`;
export const IconHeartG19 = styled(iconHeartG19)`
  ${getStyle(21, 19)}
`;
export const IconShare20 = styled(iconShare20)`
  ${getStyle(20, 20)}
`;
export const IconShareFacebook38 = styled(iconShareFacebook38)`
  ${getStyle(38, 38)}
`;
export const IconShareKakao38 = styled(iconShareKakao38)`
  ${getStyle(38, 38)}
`;
export const IconShareUrl38 = styled(iconShareUrl38)`
  ${getStyle(38, 38)}
`;
export const IconStar = styled(iconStar)`
  ${getStyle(12, 12)}
`;
export const IconStar2 = styled(iconStar2)`
  ${getStyle(18, 18)}
`;
export const IconCircleArrow = styled(iconCircleArrow)`
  ${getStyle(43, 42)}
`;
export const IconClose = styled(iconClose)`
  ${getStyle(32, 32)}
`;
export const IconClose2 = styled(iconClose2)`
  ${getStyle(24, 24)}
`;

export const IconInstargram = styled(iconInstargram)`
  ${getStyle(28, 28)}
`;
export const IconFacebook = styled(iconFacebook)`
  ${getStyle(28, 28)}
`;
export const IconYoutube = styled(iconYoutube)`
  ${getStyle(28, 28)}
`;
export const IconOutlink = styled(iconOutlink)`
  ${getStyle(16, 16)}
`;
export const IconOutlink2 = styled(iconOutlink2)`
  ${getStyle(10, 10)}
`;
export const IconPhotoDelete20 = styled(iconPhotoDelete20)`
  ${getStyle(20, 20)}
`;
export const IconArrow24 = styled(iconArrow24)`
  ${getStyle(24, 24)}
`;
export const IconErrorService = styled(iconErrorService)`
  ${getStyle(88, 74)}
`;
export const IconErrorNetwork = styled(iconErrorNetwork)`
  ${getStyle(99, 99)}
`;
export const IconTextbtnArrow18 = styled(iconTextbtnArrow18)`
  ${getStyle(18, 18)}
`;

export const IconErrorApi = styled(iconErrorApi)`
  ${getStyle(35, 35)}
`;
export const IconCheck01 = styled(iconCheck01)`
  ${getStyle(13, 18)}
`;
export const IconArrowM01 = styled(iconArrowM01)`
  ${getStyle(15, 13)}
`;
export const IconArrowW8 = styled(iconArrowW8)`
  ${getStyle(8, 8)}
`;
export const IconArrowW16 = styled(iconArrowW16)`
  ${getStyle(16, 16)}
`;
export const IconArrowH17 = styled(iconArrowH17)`
  ${getStyle(10, 17)}
`;
export const IconArrowH18 = styled(iconArrowH18)`
  ${getStyle(6, 18)}
`;
export const IconRadio20 = styled(iconRadio20)`
  ${getStyle(20, 20)}
`;
export const IconRefresh = styled(iconRefresh)`
  ${getStyle(15, 15)}
`;
export const IconReviewPhoto20 = styled(iconReviewPhoto20)`
  ${getStyle(20, 18)}
`;
export const IconArrowM02 = styled(iconArrowM02)`
  ${getStyle(19, 13)}
`;
export const IconArrow8 = styled(iconArrow8)`
  ${getStyle(13, 9)}
`;
export const IconArrow12 = styled(iconArrow12)`
  ${getStyle(12, 12)}
`;
export const IconArrowW6 = styled(iconArrowW6)`
  ${getStyle(6, 12)}
`;
export const IconArrowM15 = styled(iconArrowM15)`
  ${getStyle(15, 15)}
`;
export const IconArrowGray24 = styled(iconArrowGray24)`
  ${getStyle(24, 24)}
`;
export const IconArrowG32 = styled(iconArrowGray32)`
  ${getStyle(32, 32)}
`;
export const IconArrowGray17 = styled(iconArrowGray17)`
  ${getStyle(11, 17)}
`;
export const IconCheckBox14 = styled(iconCheckBox14)`
  ${getStyle(14, 14)}
`;
export const IconCheckbox20 = styled(iconCheckbox2N20)`
  ${getStyle(20, 20)}
`;
export const IconCheckboxC20 = styled(iconCheckbox2C20)`
  ${getStyle(20, 20)}
`;
export const IconCheckedW14 = styled(iconCheckedWhite14)`
  ${getStyle(20, 14)}
`;
export const IconLiveAlarm = styled(iconLiveAlarm)`
  ${getStyle(14, 15)}
`;
export const IconGoto = styled(iconGoto)`
  ${getStyle(10, 10)}
`;
export const IconDel16 = styled(iconDel16)`
  ${getStyle(16, 16)}
`;
export const IconDel18 = styled(iconDel18)`
  ${getStyle(18, 18)}
`;
export const IconDel20 = styled(iconDel20)`
  ${getStyle(20, 20)}
`;
export const IconDownloadOnOrange = styled(iconDownloadOnOrange)`
  ${getStyle(18, 22)}
`;
export const IconDownloadOnBlack = styled(iconDownloadOnBlack)`
  ${getStyle(19, 23)}
`;
export const IconLike12 = styled(iconLike12)`
  ${getStyle(14, 15)}
`;
export const IconListView = styled(iconListView)`
  ${getStyle(16, 16)}
`;
export const IconGridView = styled(iconGridView)`
  ${getStyle(16, 16)}
`;
export const IconInfo = styled(iconInfo)`
  ${getStyle(16, 16)}
`;
export const IconCheck02 = styled(iconCheck02)`
  ${getStyle(16, 11)}
`;
export const IconSelectCate = styled(iconSelectCategory)`
  ${getStyle(16, 16)}
`;
export const IconMovie = styled(iconMovie)`
  ${getStyle(18, 18)}
`;
export const IconMovie60 = styled(iconMovie60)`
  ${getStyle(60, 60)}
`;
export const IconArrowHdct16 = styled(iconArrowHdct16)`
  ${getStyle(16, 16)}
`;
export const IconArrowH9 = styled(iconArrowH9)`
  ${getStyle(6, 9)}
`;
export const IconArrowTW6 = styled(iconArrowTW6)`
  ${getStyle(10, 6)}
`;
export const IconArroww7 = styled(iconArrowW7)`
  ${getStyle(7, 12)}
`;
export const IconArrow20 = styled(iconArrow20)`
  ${getStyle(16, 16)}
`;
export const IconTextbtnArrow19 = styled(iconTextbtnArrow19)`
  ${getStyle(8, 14)}
`;
export const IconTimeSale48 = styled(iconTimeSale48)`
  ${getStyle(62, 60)}
`;
export const IconTimeSale72 = styled(iconTimeSale72)`
  ${getStyle(62, 60)}
`;
export const IconEvtLiveAlarm = styled(iconEvtLiveAlarm)`
  ${getStyle(19, 17)}
`;
export const IconArrowW8H14 = styled(iconArrowW8H14)`
  ${getStyle(8, 14)}
`;
export const IconArrGr5W16 = styled(iconArrGr5W16)`
  ${getStyle(16, 16)}
`;
export const IconQuestion = styled(iconQuestion)`
  ${getStyle(15, 15)}
`;

// btn
export const BtnBnbMen = styled(btnBnbMen)`
  ${getStyle(60, 60)}
`;
export const BtnBnbWomen = styled(btnBnbWomen)`
  ${getStyle(60, 60)}
`;
export const BtnBnbTop = styled(btnPageTop)`
  ${getStyle(40, 40)}
`;
export const BtnBnbHistory = styled(btnHistory)`
  ${getStyle(40, 40)}
`;
export const BtnHeaderBack = styled(btnHeaderBack)`
  ${getStyle(32, 32)}
`;
export const BtnResetFilter = styled(btnResetFilter)`
  ${getStyle(32, 32)}
`;
export const IconClockBlack = styled(iconClockBlack)`
  ${getStyle(14, 14)}
`;
export const BtnActnbrCate = styled(btnActionbarCateN32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrHeart = styled(btnActionbarHeartN32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrHistory = styled(btnActionbarHistoryN32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrHome = styled(btnActionbarHome32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrMy = styled(btnActionbarMyN32)`
  ${getStyle(32, 32)}
`;

// logo
export const LogoW = styled(logoW)`
  ${getStyle(50, 50)}
`;
export const LogoDSTANCE = styled(logoDstance)`
  ${getStyle(114, 50)}
`;
export const LogoLoadingW = styled(logoLodingW)`
  ${getStyle(60, 60)}
`;
export const LogoWconcept = styled(logoWconcept)`
  ${getStyle(118, 14.5)}
`;
export const LogoWconceptSsgLive = styled(logoWconceptSsgLive)`
  ${getStyle(284, 28)}
`;

// bg
export const BgActionbarBlack = styled(bgActionbarBlack)`
  ${getStyle(105, 50)}
`;
export const BgActionbarWhite = styled(bgActionbarWhite)`
  ${getStyle(105, 50)}
`;
export const BgCoupon = styled(bgCoupon)`
  ${getStyle(295, 132)}
`;
export const BgCoupon02 = styled(bgCoupon02)`
  ${getStyle(295, 110)}
`;
